<template>
  <div
    :class="{'opacity-all' : isHome}"
    class="main-head"
  >
    <flex
      align="center"
      justify="between"
      class="menu-wrapper"
    >
      <flex
        align="center"
        class="menu-tab-wrapper"
      >
        <img
          src="@/static/img/logo.png"
          alt="logo"
          class="logo-img"
          @click="$router.push('/home')"
        >
        <a
          v-for="(item, index) in menueList"
          :key="index"
          class="menu-item"
          @click="toPath(item)"
        >
          {{ item.name }}
        </a>
      </flex>
      <div
        v-if="showSearch"
        class="search-box"
      >
        <input
          v-model="keyword"
          class="search-input"
          placeholder="请输入关键词"
          @keyup.enter="searchByKeyword"
        >
        <flex
          align="center"
          class="search-buttons"
        >
          <el-popover
            v-model="imageUploadVisible"
            placement="bottom"
          >
            <search-image-uploader />
            <flex
              slot="reference"
              align="center"
            >
              <img
                src="@/static/img/searchByImage-black.png"
                style="height: 22px;"
              >
            </flex>
          </el-popover>
          <img
            src="@/static/img/search-icon-circle-black.png"
            style="height: 20px;"
            @click="searchByKeyword(keyword)"
          >
        </flex>
      </div>
      <flex
        align="center"
        class="user-box"
      >
        <el-button
          type="primary"
          style="height: 32px; line-height: 0px;"
          @click="$router.push('/image-search')"
        >
          立即购买
        </el-button>
        <flex
          align="center"
          class="menu-item option-item"
          @click="toPersonCenter"
        >
          <img src="@/static/img/home/gongtu-black.png">
          供图
        </flex>
        <el-popover
          v-if="userInfo.user_id"
          placement="bottom"
          width="100px"
          trigger="hover"
        >
          <div class="user-options">
            <flex
              v-for="(item, index) in userOptionsByFilter"
              :key="index"
              align="center"
              class="options-item"
              @click="handleUserOption(item)"
            >
              <svg-icon
                :icon-class="item.icon"
                class="user-icon"
              />
              <span>{{ item.name }}</span>
            </flex>
          </div>
          <!-- <img
            slot="reference"
            :src="userInfo.icon ? userInfo.icon : 'static/img/avatar.png'"
            class="avator-img"
            alt=""> -->
          <span
            slot="reference"
            class="menu-item option-item"
          >
            {{ userInfo.nick_name }}
          </span>
        </el-popover>
        <a
          v-else
          class="option-item"
          @click="login"
        >
          注册/登录
        </a>
      </flex>
    </flex>
    <main-dialog
      :visible.sync="visible"
      :close-on-modal="false"
      comm-class="no-header"
      width="450px"
      top="22vh"
    >
      <login
        :bound-weixin-status="boundWeixinStatus"
        @close="handleClose"
        @finish="finishLogin"
      />
    </main-dialog>
  </div>
</template>

<script>
import Login from '@/components/Person/Login'
import SearchImageUploader from '@/components/Search/SearchImageUploader'
import { removeToken } from '@/utils/auth'

export default {
  components: {
    Login,
    SearchImageUploader
  },
  data () {
    return {
      menueList: [
        {
          name: '首页',
          path: '/home'
        },
        {
          name: '图片资源',
          path: '/image-search'
        },
        {
          name: '定制图库',
          path: '/custom-pictures'
        },
        {
          name: '主题活动',
          path: '/theme-active'
        },
        {
          name: '摄影师',
          path: '/sign-photographer'
        },
        {
          name: '平台服务',
          path: '/copyright-service'
        }
        // {
        //   name: '新闻官网',
        //   method: 'toUrl',
        //   url: 'http://news.gty.gzxwtpw.com/'
        // }
      ],
      userOptions: [
        {
          name: '个人中心',
          icon: 'personal-center',
          method: 'toPath',
          path: '/person/personal-center/info'
        },
        {
          name: '我的收藏',
          icon: 'collection',
          method: 'toPath',
          path: '/person/collection'
        },
        {
          name: '我的作品',
          icon: 'upload',
          method: 'toPath',
          auth: 'isPhotoGrapher',
          path: '/person/mine-works'
        },
        {
          name: '购物车',
          icon: 'cart',
          method: 'toPath',
          path: '/person/shopping-cart'
        },
        {
          name: '订单管理',
          icon: 'order',
          method: 'toPath',
          path: '/person/order-manage'
        },
        {
          name: '结算中心',
          icon: 'settlement',
          method: 'toPath',
          auth: 'isPhotoGrapher',
          path: '/person/settlement/account'
        },
        {
          name: '摄影师认证',
          icon: 'auth',
          method: 'toPath',
          path: '/person/photographer-auth'
        },
        {
          name: '退出',
          icon: 'exit',
          method: 'loginOut'
        }
      ],
      imageUploadVisible: false,
      keyword: '',
      visible: false,
      boundWeixinStatus: false // 是否是在绑定微信
    }
  },
  computed: {
    isHome () {
      return this.$route.path === '/home'
    },
    showSearch () {
      return !this.$route.path.includes('image-search')
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    // 是否是摄影师
    isPhotoGrapher () {
      return this.userInfo.certification_flag === 3
    },
    // 微信code
    weixinCode () {
      return this.$route.query.code
    },
    userOptionsByFilter () {
      return this.userOptions.filter(item => {
        if (item.auth) {
          return this[item.auth]
        } else {
          return item
        }
      })
    }
  },
  mounted () {
    this.initThirdLogin()
    // 设置关键词搜索
    this.$root.eventHub.$on('set-keyword-by-search', (keyword) => {
      this.setKeywordToSearch(keyword)
    })
    // 打开登录框
    this.$root.eventHub.$on('get-login', () => {
      this.visible = true
    })
    // 绑定微信
    this.$root.eventHub.$on('bound-weixin', () => {
      this.visible = true
      this.boundWeixinStatus = true
    })
    // 退出登录
    this.$root.eventHub.$on('login-out', () => {
      this.loginOut(true)
    })
    if (this.$route.query && this.$route.query.toLogin) {
      if (!this.userInfo.user_id) {
        this.login()
        this.$router.push(this.$route.path)
      } else {
        if (this.$route.query && this.$route.query.photographer) {
          this.$router.push('/person/photographer-auth')
        }
      }
    }
  },
  destroyed () {
    this.$root.eventHub.$off('set-keyword-by-search')
    this.$root.eventHub.$off('get-login')
    this.$root.eventHub.$off('bound-weixin')
    this.$root.eventHub.$off('login-out')
  },
  methods: {
    initThirdLogin () {
      if (this.weixinCode && !this.$route.path.includes('settlement/account')) {
        this.visible = true
      }
    },
    // 处理操作
    handleUserOption (item) {
      this[item.method](item)
    },
    openUrl (url) {
      window.open(url, '_blank')
    },
    // 前往
    toPath (item) {
      if (item.method === 'toUrl') {
        window.open(item.url, '_blank')
        return
      }
      this.$router.push({
        path: item.path
      })
    },
    // 注册
    register () {
      this.visible = true
    },
    // 登录
    login () {
      this.visible = true
    },
    handleClose () {
      this.visible = false
      this.boundWeixinStatus = false
    },
    // 完成登录
    finishLogin () {
      this.visible = false
      this.$message.success('登录成功！')
    },
    // 退出登录
    loginOut (noMessage) {
      this.$store.commit('SET_USER_INFO', {})
      removeToken()
      this.$router.push('/home')
      if (!noMessage) {
        this.$message.success('退出登录成功！')
      }
    },
    // 设置关键词搜索
    setKeywordToSearch (keyword) {
      this.keyword = keyword
      this.searchByKeyword()
      // this.$router.push(this.$route.path)
    },
    // 关键字搜索
    searchByKeyword () {
      if (!this.keyword) return
      if (this.$route.path.includes('image-search')) {
        this.$root.eventHub.$emit('search-by-keyword', this.keyword)
        this.keyword = ''
      } else {
        let routerData = this.$router.resolve({
          path: '/image-search',
          query: {
            keywords: this.keyword
          }
        })
        window.open(routerData.href, '_blank')
      }
    },
    toPersonCenter () {
      if (this.userInfo.user_id) {
        if (this.userInfo.certification_flag === 3) {
          this.$router.push('/person/mine-works/works-manage')
        } else {
          this.$router.push('/person/photographer-auth')
        }
      } else {
        this.visible = true
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.main-head
  font-family PuHuiTi-Medium
  position fixed
  top 0px
  width 100%
  box-sizing border-box
  background-color #fff
  padding 0px 40px
  z-index 999
.menu-wrapper
  height 70px
  padding 15px 0px
  box-sizing border-box
.menu-tab-wrapper
  flex 1
  padding-right 100px
.logo-img
  cursor pointer
  width 117px
  height 40px
  object-fit contain
.menu-item
  flex none
  position relative
  cursor pointer
  margin-left 40px
  // transition all .2s ease-in-out
  text-decoration none
  color rgba(0, 0, 0, 0.8)
  &>img
    width 22px
    height 18px
    margin-right 12px
  &:hover
    color rgba(0, 0, 0, 1)
.option-item
  cursor pointer
  margin-left 40px
  &:hover
    // font-family PuHuiTi-Medium
    &:before
      display none
.avator-img
  cursor pointer
  flex none
  width 42px
  height 42px
  margin-left 40px
  border-radius 50%
  object-fit contain
  border 1px solid #f1f1f1
.search-box
  flex 1
  position relative
  box-sizing border-box
  margin-right 30px
@media (max-width 1700px)
  .search-box
    display none
.search-input
  width 100%
  height 45px
  font-size 14px
  color #333
  padding 0px 150px 0px 20px
  box-sizing border-box
  border-radius 4px
  outline none
  border 1px solid #333
  &::placeholder
    color #999
.search-buttons
  position absolute
  right 10px
  top 50%
  transform translateY(-50%)
  img
    cursor pointer
    margin 0px 14px
    transition all 0.2s
    &:hover
      opacity 0.8
  .input-icon
    cursor pointer
    width 28px
    height 28px
    margin 0px 18px
    transition all 0.1s
    &:hover
      opacity 0.8
.options-item
  cursor pointer
  font-size 14px
  padding 15px 0px
  .svg-icon
    font-size 16px
    margin-right 16px
  &:hover
    font-family PuHuiTi-Medium
    color #BD2124
  &:last-child
    border-top 1px solid #ccc
</style>
